/**
 * @file BenefitGrid.js
 * @description Responsive grid of BenefitCard components.
 */

import BenefitCard from './BenefitCard';
import styles from './BenefitGrid.module.scss';
import NotFoundBox from '../../ui/no_data_indicators/NotFoundBox';
import { getText } from '../../../i18n';

export default function BenefitGrid({ enrollments, planYearId, emptyState }) {
    if (!enrollments || enrollments.length === 0) {
        return (
            emptyState ?? (
                <NotFoundBox
                    backgroundColor="#f0f4ff"
                    title={getText('msg_6b97259cfa63')}
                    description={getText('msg_87ac069f5dda')}
                />
            )
        );
    }

    return (
        <div className={styles.grid}>
            {enrollments.map(enrollment => (
                <BenefitCard
                    key={enrollment.id}
                    enrollment={enrollment}
                    planYearId={planYearId}
                />
            ))}
        </div>
    );
}
